import { render, staticRenderFns } from "./License.vue?vue&type=template&id=7cc6828e&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"
import style0 from "./License.vue?vue&type=style&index=0&id=7cc6828e&prod&scoped=true&lang=scss&"
import style1 from "./License.vue?vue&type=style&index=1&id=7cc6828e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6828e",
  null
  
)

export default component.exports